import { Cobranding } from '../../utilities/cobranding/cobranding';
import { CobrandingComponents } from './shared-cobranding';

import DefaultCobranding from './DefaultCobranding';
import BitbucketCobranding from './bitbucket/BitbucketCobranding';
import CompassCobranding from './compass/CompassCobranding';
import ConfluenceCobranding from './confluence/ConfluenceCobranding';
import JiraCobranding from './jira/JiraCobranding';
import OpsgenieCobranding from './opsgenie/OpsgenieCobranding';
import StatuspageCobranding from './statuspage/StatuspageCobranding';
import TrelloCobranding from './trello/TrelloCobranding';
import WacCobranding from './wac/WacCobranding';
import AtlasCobranding from './atlas/AtlasCobranding';
import WacSignupOTPExperimentJira from './wac/WacSignupOTPExperimentJira';
import WacSignupOTPExperimentConfluence from './wac/WacSignupOTPExperimentConfluence';
import BXPSU2453Variant1Cobranding from './wac/bxpsu2453-v1/BXPSU2453Variant1Cobranding';
import BXPSU2453Variant2Cobranding from './wac/bxpsu2453-v2/BXPSU2453Variant2Cobranding';
import BXPSU2618Variant1Cobranding from './wac/bxpsu2618-v1/BXPSU2618Variant1Cobranding';
import LoomCobranding from './loom/LoomCobranding';

const cobrandingMap: { [K in Cobranding]: CobrandingComponents } = {
  [Cobranding.NO_COBRANDING]: DefaultCobranding,
  [Cobranding.BITBUCKET]: BitbucketCobranding,
  [Cobranding.COMPASS]: CompassCobranding,
  [Cobranding.CONFLUENCE]: ConfluenceCobranding,
  [Cobranding.JIRA]: JiraCobranding,
  [Cobranding.LOOM]: LoomCobranding,
  [Cobranding.OPSGENIE]: OpsgenieCobranding,
  [Cobranding.STATUSPAGE]: StatuspageCobranding,
  [Cobranding.TRELLO]: TrelloCobranding,
  [Cobranding.WAC]: WacCobranding,
  [Cobranding.ATLAS]: AtlasCobranding,
  [Cobranding.WAC_SIGNUP_OTP_EXPERIMENT_JIRA]: WacSignupOTPExperimentJira,
  [Cobranding.WAC_SIGNUP_OTP_EXPERIMENT_CONFLUENCE]: WacSignupOTPExperimentConfluence,
  [Cobranding.WAC_BXPSU_2453_V1]: BXPSU2453Variant1Cobranding,
  [Cobranding.WAC_BXPSU_2453_V2]: BXPSU2453Variant2Cobranding,
  [Cobranding.WAC_BXPSU_2618_V1]: BXPSU2618Variant1Cobranding,
};

export const getCobrandedComponents = (cobranding: Cobranding): CobrandingComponents =>
  cobrandingMap[cobranding];
